export class PictureUrlFactory {
    constructor(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    getPictureUrl(pictureId) {
        return new URL(`picture/${pictureId}`, this.serviceUrl).href;
    }
}
